import Axios from 'axios';
import { PLATFORMS } from 'helpers/constants';
import moment from 'moment-timezone';
import { getParameterByName } from '../helpers/commons';
import { processDefaultValues } from '../helpers/defaults';

export const fetchCurrentCalendarData = async (
	calendarId,
	instance,
	platform,
	mode,
	originCompId,
	time_zone = moment.tz.guess()
) => {
	try {
		const data = await Axios.get(`${process.env.BOOMTECH_API}published_calendar`, {
			params: {
				comp_id: calendarId,
				instance,
				originCompId,
				time_zone
			},
			headers: { PLATFORM: platform, mode }
		});
		if (!data.data.settings && platform === PLATFORMS.WIX) {
			const processedData = Wix.Styles.getStyleParams();
			saveSettings(processedData, 'settings');
		}
		return data;
	} catch (err) {
		throw new Error();
	}
};

export const getIntegrationTokens = async (app_id, addons) => {
	try {
		const tokenIntegrationsList = ['ticket_spice', 'google_analytics'];

		if (addons.some(item => tokenIntegrationsList.includes(item.name))) {
			const response = await Axios.get(
				`${process.env.INTEGRATIONS_SERVICE_URL}tokens?app=calendar&platform=wix&app_id=${app_id}`
			);

			return response.data;
		} else {
			return {};
		}
	} catch (err) {
		throw new Error();
	}
};

export const updateOption = (
	{ comp_id = 'UNASSIGNED', instance = 'UNASSIGNED', platform = PLATFORMS.WIX, status = 1 },
	params
) => {
	fetch(`${process.env.BOOMTECH_API}option`, {
		method: 'PUT',
		body: JSON.stringify({
			comp_id,
			instance,
			...params
		}),
		headers: {
			'Content-type': 'application/json; charset=UTF-8',
			'PLATFORM': platform
		}
	});
};

export const saveSIteInfo = (optionData, currentUrl = '') => {
	Wix.getSiteInfo(siteInfo2 => {
		let pageTitle = siteInfo2.pageTitleOnly;
		Wix.getSiteMap(siteInfo => {
			Wix.getCurrentPageId(pageId => {
				let mainPageId,
					subPageId,
					subPageUrl,
					mainPageUrl = '';

				for (var key in siteInfo) {
					let page = siteInfo[key];
					if (!page) break;
					if (page.pageId == '#' + pageId) {
						mainPageId = page.pageId;
						mainPageUrl = page.url;
					}
					for (var key1 in page.subPages ? page.subPages : '') {
						var subPage = page.subPages[key1];

						if (!subPage) break;
						if (subPage.pageId == '#' + pageId) {
							subPageId = subPage ? subPage.pageId : '';
							subPageUrl = subPage ? subPage.url : '';
						}
					}
				}

				if (mainPageId == '#' + pageId || subPageId == '#' + pageId) {
					const pageUrlToSave = mainPageId == '#' + pageId ? mainPageUrl : subPageUrl;
					if (
						!pageUrlToSave.includes('https://editor.wix.com') &&
						pageUrlToSave !== currentUrl
					)
						updateOption(optionData, {
							published: 1,
							url: pageUrlToSave
						});
				}
			});
		});
	});
};

export const saveMemberInfo = optionData => {
	Wix.getSiteInfo(({ pageTitleOnly: pageTitle }) => {
		Wix.currentMember(memberDetails => {
			updateOption(optionData, {
				info: memberDetails,
				name: pageTitle,
				published: 1
			});
		});
	});
};

export const updateEvent = (body, platform, onSuccess, method) => {
	Axios({
		url: `${process.env.BOOMTECH_API}event`,
		method: method,
		data: JSON.stringify(body),
		headers: {
			'PLATFORM': platform,
			'Content-type': 'application/json; charset=UTF-8'
		}
	}).then(res => {
		onSuccess(res.data);
	});
};

export const saveSettings = (updates, endPoint) => {
	const body = processDefaultValues(updates);
	const comp_id = Wix.Utils.getCompId();
	const instance = getParameterByName('instance');
	Axios({
		url: `${process.env.BOOMTECH_API + endPoint}?comp_id=${comp_id}&instance=${instance}`,
		method: 'POST',
		data: JSON.stringify(body),
		headers: {
			'PLATFORM': PLATFORMS.WIX,
			'Content-type': 'application/json; charset=UTF-8'
		}
	}).then(res => {
		res;
	});
};

export const setWeeblyUserEmail = (weeblyData, site_id) => {
	fetch(`${process.env.BOOMTECH_API}user_email?site_id=${site_id}`)
		.then(res => res.json())
		.then(data => {
			weeblyData.settings.set('user_email', data.email);
			weeblyData.settings.save();
		});
};
